module.exports = __webpack_public_path__ + "d5d040b6e220b5e521c1ba4fd8c74839.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-320.webp.png
// module id = 428
// module chunks = 0